'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var sweepSortAnalyzer = require("../../mobileCore/main/analyzer/sweepSortAnalyzer");
var conversionUtils = require("../../mobileCore/main/conversionUtils");
function splitToFragments(siblings, axis) {
    var sweepLineEvents = sweepSortAnalyzer.createEventsQueue(siblings, axis);
    return sweepSortAnalyzer.createFragments(sweepLineEvents);
}
exports.splitToFragments = splitToFragments;
function sortSiblings(components) {
    if (_.size(components) <= 1) {
        return components;
    }
    var rowsComponents = _.map(splitToFragments(components, 'y'), 'comps');
    return _.reduce(rowsComponents, function (sortedComponents, rowComponents) {
        if (_.size(rowComponents) === 1) {
            return sortedComponents.concat(rowComponents);
        }
        var columnsComponents = _.map(splitToFragments(rowComponents, 'x'), 'comps');
        var sortedColumnsComponents = _.flatMap(columnsComponents, function (columnComponents) {
            return _.size(columnComponents) === 1 ? columnComponents : _.sortBy(columnComponents, _.findIndex.bind(null, components));
        });
        return sortedComponents.concat(sortedColumnsComponents);
    }, []);
}
exports.sortSiblings = sortSiblings;
function getComponentsOrder(parent) {
    var children = conversionUtils.getChildren(parent);
    if (!children) {
        return {};
    }
    var sortedChildren = sortSiblings(children);
    var parentOrderMap = _.set({}, parent.id, _.map(sortedChildren, 'id'));
    var childrenOrderMaps = _.map(children, getComponentsOrder);
    return _.assign.apply(_, [parentOrderMap].concat(childrenOrderMaps));
}
exports.getComponentsOrder = getComponentsOrder;



//////////////////
// WEBPACK FOOTER
// ./src/mobileLayoutUtils/main/sortingUtils.ts
// module id = 18
// module chunks = 1